export const removeLangFromPath = (path: string): string => {
  return path.replace(/^\/(de|en)(?=\/|$)/, '')
}
